import React from 'react';
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/bff/client';
import { Header, Button } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Header.css';
import '@spotahome/ui-library/lib/components/Button.css';

import './HeaderNav.scss';

// 🚨 LEGACY COMPONENT
import LanguageSwitcherContainer from '../../LEGACY/javascripts/ui/menu/language-switcher-container';

import LoginButton from './login/LoginButton';

const HeaderNav = ({ options }) => (
  <Header.Nav>
    {options.includes('landlord-panel') && (
      <Header.Item>
        <Header.Link
          color="dark"
          href={getPagePath('landlord-panel')}
          className="ga-landlord-panel-login header-button"
          alt
        >
          {trans('landingpage.button.landlord')}
        </Header.Link>
      </Header.Item>
    )}

    {options.includes('list-your-property') && (
      <Header.Item>
        <Button
          href={getPagePath('externals.landing-pages.list-your-property')}
          className="ga-home-publish-your-property-top header-button"
          alt
        >
          {trans('landingpage.button.landlord')}
        </Button>
      </Header.Item>
    )}

    {options.includes('how-it-works') && (
      <Header.Item>
        <Header.Link
          color="dark"
          href={getPagePath('externals.landing-pages.how-it-works')}
          target="_blank"
          className="ga-menu-faqs"
        >
          {trans('how_it_works.title')}
        </Header.Link>
      </Header.Item>
    )}

    {options.includes('favorites') && (
      <Header.Item>
        <Header.Link
          color="dark"
          className="ga-menu-favorites"
          href={getPagePath('marketplace.favorites')}
          target="_blank"
        >
          {trans('favorites.title.favorites')}
        </Header.Link>
      </Header.Item>
    )}

    <LoginButton />

    <Header.Item>
      <Header.Link
        color="dark"
        href={getPagePath('externals.landing-pages.help-center')}
      >
        {trans('help.title')}
      </Header.Link>
    </Header.Item>

    <Header.Item>
      <Header.Link color="dark">
        <LanguageSwitcherContainer abbreviated />
      </Header.Link>
    </Header.Item>
  </Header.Nav>
);

HeaderNav.defaultProps = {
  options: ['list-your-property', 'how-it-works', 'favorites']
};

HeaderNav.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOf([
      'landlord-panel',
      'list-your-property',
      'how-it-works',
      'favorites'
    ])
  )
};

export default HeaderNav;
